export default "__VITE_ASSET__DrzZjukC__"